import React from 'react';
import ServicesHeroSection from '../components/ServicesHeroSection';
import ServicesDeepFoundationsSection from '../components/ServicesDeepFoundationsSection';
import ServicesIndustrialSection from '../components/ServicesIndustrialSection';
import ServicesNationBuildingSection from '../components/ServicesNationBuildingSection';
import ServicesUrbanFoundationsSection from '../components/ServicesUrbanFoundationsSection';
import BlogSection from '../components/BlogSection';
import ContactUsSection from '../components/ContactUsSection';
import FooterSection from '../components/FooterSection';

function ServicesPage() {
  return React.createElement('div', { className: 'figma-viewport' },
    React.createElement('div', { className: 'section-animate' }, React.createElement(ServicesHeroSection)),
    React.createElement('div', { className: 'section-animate' }, React.createElement(ServicesDeepFoundationsSection)),
    React.createElement('div', { className: 'section-animate' }, React.createElement(ServicesIndustrialSection)),
    React.createElement('div', { className: 'section-animate' }, React.createElement(ServicesNationBuildingSection)),
    React.createElement('div', { className: 'section-animate' }, React.createElement(ServicesUrbanFoundationsSection)),
    React.createElement('div', { className: 'section-animate' }, React.createElement(BlogSection)),
    React.createElement('div', { className: 'section-animate' }, React.createElement(ContactUsSection)),
    React.createElement('div', { className: 'section-animate' }, React.createElement(FooterSection))
  );
}

export default ServicesPage;
